import { Box, HStack } from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';
import { ReactNode } from 'react';

import { OverflowContainer } from '../../overflow-tooltip';

export function FilterLabelRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <HStack spacing={1} w="full" minW={0}>
      <OverflowContainer.Tooltip
        label={label}
        hasArrow
        fontSize="sm"
        openDelay={500}
        placement="top-start"
      >
        <Text lines={1} isGrow color="muted" size="sm">
          {label}
        </Text>
      </OverflowContainer.Tooltip>
      <Box flexShrink={0}>{children}</Box>
    </HStack>
  );
}
